import * as React from 'react';
import { TabViewModelImpl } from '../../../toolkit/tabs/tab/tabviewmodel';
import { ToneDto, ToneDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/tonedto';
import { UIComponentState } from '../../../toolkit/uicomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { ListViewModel } from '../../../toolkit/horizontallist/listviewmodel';
import { PopUpWrapperComponent } from '../../popup/popupwrappercomponent';
import { InfoComponent } from '../../popup/info/infocomponent';
import { Strings } from 'src/com/sixdee/crbtportal/utils/resources/strings';
import './mytunes-tab-info-style.css';
import { GridComponent, GridComponentProps } from '../../../toolkit/grid/gridcomponent';

export class TunesListTabViewModelImpl extends TabViewModelImpl
{
    popupComponent:PopUpWrapperComponent;
    private ref: GridComponent<GridComponentProps<ToneDto>, UIComponentState>;

    constructor(private context: BaseContext, private title: string, 
        private listViewModel: ListViewModel<ToneDto>)
    {
        super();
        this.infoClick = this.infoClick.bind(this);
        this.closePopup = this.closePopup.bind(this);
    }

    
    getTitle(): string 
    {
        return this.title;
    }

    getTabView(): JSX.Element
    {
        // this.listViewModel.setListDatas(this.getListOfTones());
        //add learn more link for info pop up
        return (
            <>
                {/* {
                        this.getWebView()
                    } */}
               <div id="mytunes-tab-info">
                    {
                        this.getWebView()
                    }
                </div> 
               
                {/* <div id="mytunes-tab-info-mobile">
                    {
                        this.getMobileView()
                    }
                </div> */}
            <GridComponent ref={(item: any) => this.ref = item} listViewModel={this.listViewModel} context={this.context}/>
                {/* <VerticalListComponent ref={(item: any) => this.ref = item} listViewModel={this.listViewModel} context={this.context}/> */}
                <PopUpWrapperComponent ref={(item: any) => this.popupComponent = item} context={this.context}/>

            </>
        );

    }

    getWebView()
    {
        return (
            <div id="tune-list-wrapper" style={{}}>
            <label id="tune-list-label" style={{fontFamily:this.context.getResources().getFontFamily()}}>
                   {this.context.getResources().getString(Strings.how_to_play_selected_tunes_to_your_callers)}
            </label>
            <label id="tune-list-info-label" onClick={this.infoClick} style={{fontFamily:this.context.getResources().getFontFamily(),}}>
            {this.context.getResources().getString(Strings.learn_more)}
            </label>
         </div>
        );
    }

    // getMobileView()
    // {
    //     return (
    //         <div style={{width:'100%',marginTop:'0px',textAlign:'left',display:'flex', height:'10px', lineHeight:'10px',fontSize:'7px'}}>
    //         <label style={{width:'auto',fontFamily:this.context.getResources().getFontFamily(), height:'100%',color:'#898989',fontWeight:900}}>
    //                {this.context.getResources().getString(Strings.how_to_play_selected_tunes_to_your_callers)}
    //         </label>
    //         <label onClick={this.infoClick} style={{width:'100px', cursor: "pointer",fontFamily:this.context.getResources().getFontFamily(),marginLeft:'6px', fontWeight:900,height:"100%",color:'#003187'}}>
    //         {this.context.getResources().getString(Strings.learn_more)}
    //         </label>
    //      </div>
    //     );
    // }
    
    infoClick():void
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(true,
            <InfoComponent headerTitle={this.context.getResources().getString(Strings.info)} onOkClick={this.closePopup} closePopup={this.closePopup} context={this.context}/>);
    }
    protected closePopup()
    {
        this.popupComponent !== null && this.popupComponent.setShowWindow(false, <></>);
    }
    updateTabData(listOfDatas: ToneDto[])
    {
        this.listViewModel.setListDatas(listOfDatas);

        this.ref !== null && this.ref.forceUpdateComponent();
    }

    deleteData(id: string)
    {
        this.listViewModel.deleteData(id);

        this.ref !== null && this.ref.forceUpdateComponent();
    }

     getListOfTones()
    {  let tone1 = new ToneDtoImpl();
        tone1.setId("1");
        tone1.setToneName("1234rsva");
        tone1.setArtistName("987ytrfgbnmk jhgfdsdfghjk jhgfdfghjk ");
        tone1.setImgPath("http://placehold.it/120x120&text=image1");

        let tone2 = new ToneDtoImpl();
        tone2.setId("2");
        tone2.setToneName("1234rsva");
        tone2.setArtistName("987ytrfgbnmk 87654 87654");
        tone2.setImgPath("http://placehold.it/120x120&text=image2");

        let tone3 = new ToneDtoImpl();
        tone3.setId("3");
        tone3.setToneName("1234rsva");
        tone3.setArtistName("987ytrfgbnmk9 87659876545678");
        tone3.setImgPath("http://placehold.it/120x120&text=image3");

        let tone4 = new ToneDtoImpl();
        tone4.setId("4");
        tone4.setToneName("1234rsva");
        tone4.setArtistName("987ytrfgbnmk");
        tone4.setImgPath("http://placehold.it/120x120&text=image4");

    //     // let tone5 = new ToneDtoImpl();
    //     // tone5.setId("5");
    //     // tone5.setToneName("1234rsva");
    //     // tone5.setArtistName("987ytrfgbnmk");
    //     // tone5.setImgPath("http://placehold.it/120x120&text=image5");

    //     // let tone6 = new ToneDtoImpl();
    //     // tone6.setId("6");
    //     // tone6.setToneName("1234rsva");
    //     // tone6.setArtistName("987ytrfgbnmk");
    //     // tone6.setImgPath("http://placehold.it/120x120&text=image6");

    //     // let tone7 = new ToneDtoImpl();
    //     // tone7.setId("7");
    //     // tone7.setToneName("1234rsva");
    //     // tone7.setArtistName("987ytrfgbnmk");
    //     // tone7.setImgPath("http://placehold.it/120x120&text=image7");

    //     // let tone8 = new ToneDtoImpl();
    //     // tone8.setId("8");
    //     // tone8.setToneName("1234rsva");
    //     // tone8.setArtistName("987ytrfgbnmk");
    //     // tone8.setImgPath("http://placehold.it/120x120&text=image8");
        return [tone1, tone2, tone3, tone4];
    }
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunes/tuneslisttabviewmodel.tsx